import { render, staticRenderFns } from "./activation.vue?vue&type=template&id=4f24659d&"
import script from "./activation.vue?vue&type=script&lang=ts&"
export * from "./activation.vue?vue&type=script&lang=ts&"
import style0 from "./activation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports